export const numOrNull = (value: string | null | undefined | number): number | null => (value === null || value === undefined) ? null : +value;
